<template>
  <div v-if="group.name !== undefined" class="simcard-group__config">
    <div class="simcard-group__config-header">
      <fg-input
        v-model="group.name"
        class="name"
        type="text"
        placeholder="name group"
        @keydown.enter="save_config"
      />
      <button type="submit" class="mdi mdi-content-save btn btn-success" @click.prevent="save_config">
        <b>{{translate('config.save')}}</b>
      </button>

      <router-link class="mdi mdi-eye btn btn-success" :to="open_simcard_devices_group(group.id)">
        <b>{{translate('config.show_group_simcards_devices')}}</b>
      </router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SimCardDevicesConfig',
  components: {
  },
  props: ['group'],
  data () {
    return {config: {multi_instance: {}}}
  },
  watch: {
  },
  methods: {
    open_simcard_devices_group(id){
      return {path: '/simcard_devices_group/' + id}
    },
    save_config () {
      this.$http.v1.updateSimcardGroup({...this.group},(response) => {
          this.global_notify('info', this.translate('simcard_devices_group_list.update'))
          this.$store.dispatch('groupSimcardDevicesUpdate')
      })
    },
  }
}
</script>

<style lang='scss' scoped>
  .simcard-group{
    &__config{
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding: 10px;
      &-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .name{
          width: 50%;
          margin-bottom: 0;
        }
        .btn{
          padding: 7px;
        }
      }
      &-main{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        textarea{
          flex: 10;
          width: 100%;
          overflow: auto;
        }
      }
      &-multi_instance{
        flex: 10;
        width: 100%;
        height: 100%;
        overflow: auto;
        &-item{
          flex: 2;
          display: flex;
          flex-direction: column;
          textarea{
            width: 100%;
            overflow: auto;
            flex:2;
          }
        }
        .left-pane{
          display: flex;
          flex-direction: column;
          height: 100%;
          textarea{
            flex:20;
            width: 100%;
            overflow: auto;
          }
        }
        .right-pane{
          display: flex;
          flex-direction: column;
          height: 100%;
        }
      }
    }
  }

  @media (max-width:768px) {
    .simcard-group{
      &__config{
      padding: 10px 0;
        &-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .name{
            width: 70%;
            margin-bottom: 0;
          }
          .btn{
            width: 15%;
            margin-left: 10px;
            padding: 7px;
            b{
              display: none;
            }
          }
        }
      }
    }
  }

</style>
